module.exports = __webpack_public_path__ + "static/media/searchIcon.1ad5c257.svg";